export const getPostCount = (state: any) => state.postCount;
